import type { PartnerRoleFacts } from "@kundeninfo/api-client";
import type { AktenTabId } from "./KundenAkte.js";

/**
 * DIE REITER DER AKTE JE ROLLE (Spec „Reiter der Akte je Rolle“, Lieferanten Aufgabe 22). Sichtbar sind Reiter nach den
 * Rollen der Firma über alle sichtbaren Beziehungen (`roleFacts`, P25) — damit der Schalter „alle“ der Belegreiter
 * weiter funktioniert:
 *
 *  - Angebote, Aufträge, Rechnungen: eine Beziehung mit Kundenrolle oder schon Vorgänge (ein ehemaliger Kunde behält
 *    seine Belege);
 *  - Lieferverträge, Eingangsrechnungen: eine Beziehung mit Lieferantenrolle oder schon Verträge/Eingangsrechnungen —
 *    UND der Benutzer sieht Lieferantendaten (Entscheid 496; EDITOR nie, auch nicht bei Lieferantenrolle);
 *  - alle übrigen: immer.
 */
export const CUSTOMER_TABS: readonly AktenTabId[] = ["angebote", "auftraege", "rechnungen"];
export const SUPPLIER_TABS: readonly AktenTabId[] = ["liefervertraege", "eingangsrechnungen"];

/** Ohne Rollenfakten (ein Schreibweg antwortet ohne sie) gelten alle Rollen — wie in der Kundenübersicht. */
export const ALL_ROLES: PartnerRoleFacts = {
  customerRole: true, supplierRole: true, customerDocuments: true, supplierDocuments: true };

export function visibleTabs<T extends { id: AktenTabId }>(
  tabs: readonly T[], f: { roleFacts: PartnerRoleFacts; supplierView: boolean },
): T[] {
  const customer = f.roleFacts.customerRole || f.roleFacts.customerDocuments;
  const supplier = f.supplierView && (f.roleFacts.supplierRole || f.roleFacts.supplierDocuments);
  return tabs.filter((t) => (CUSTOMER_TABS.includes(t.id) ? customer : SUPPLIER_TABS.includes(t.id) ? supplier : true));
}
